import React,{Component} from 'react';
import Form1 from './Form1'
import Form2 from './Form2'
import Table from './Table'
class App extends Component
{	
	
	render()
	{
		return (
				<div>
					<Form1 />
					<Form2 />
					<Table/>
				</div>
			)
	}
}

export default App;